import { Company, User } from '@interfaces';

export interface UserSupportingCompany {
  id: string;
  user?: Partial<User>;
  userId: string;
  company?: Partial<Company>;
  companyId: string;

  canViewProcesses: boolean;
  canEditProcesses: boolean;

  createdAt: Date;
  updatedAt: Date;
}
export enum SupportingCompanyAccessLevel {
  'canViewProcesses' = 'canViewProcesses',
  'canEditProcesses' = 'canEditProcesses',
}
export interface UpdateUserSupportingCompanyOpts {
  companyId: string;
  userId: string;
  canViewProcesses: boolean;
  canEditProcesses: boolean;
}
